import React from 'react';
import styled from 'styled-components';
import { EmptyState } from '@teals/ui-web';

const PageBody = styled.div`
  padding: 2rem 0 4rem;
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const PageHeader = styled.div`
  margin-bottom: 2rem;

  h1 {
    font-size: 1.5rem;
    margin-bottom: 0.25rem;
  }

  p {
    font-size: 0.875rem;
    color: var(--text-muted);
  }
`;

const MissionControl: React.FC = () => (
  <PageBody className="fade-in">
    <Container>
      <PageHeader>
        <h1>Mission Control</h1>
        <p>
          Your operational hub for recent workspace sessions, activity, and
          organisation-wide notifications.
        </p>
      </PageHeader>

      <EmptyState
        title="Coming soon"
        description="Recent workspace sessions, an activity feed, and quick actions (new session, playground, analytics) will appear here."
      />
    </Container>
  </PageBody>
);

export default MissionControl;
